// @flow

import type {
  Action,
} from 'fc-flow-types/redux'

// Action Types
import {
  FETCH_COMMENTS,
  FETCH_HEFTY_CROPS,
} from './constants'

export const fetchComments = function (payload: Object): Action<void> {
  return {
    type: FETCH_COMMENTS,
    payload,
  }
}

export function fetchHeftyCrops (): Action<void> {
  return {
    type: FETCH_HEFTY_CROPS,
  }
}
